/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Coming_SoonInputs */

const en_clients_coming_soon = /** @type {(inputs: Clients_Coming_SoonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Client management coming soon.`)
};

const pt_br2_clients_coming_soon = /** @type {(inputs: Clients_Coming_SoonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestão de clientes em breve.`)
};

/**
* | output |
* | --- |
* | "Client management coming soon." |
*
* @param {Clients_Coming_SoonInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_coming_soon = /** @type {((inputs?: Clients_Coming_SoonInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Coming_SoonInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_coming_soon(inputs)
	return pt_br2_clients_coming_soon(inputs)
});